import { render, staticRenderFns } from "./ImportBox.vue?vue&type=template&id=e18df318&scoped=true"
import script from "./ImportBox.vue?vue&type=script&lang=ts"
export * from "./ImportBox.vue?vue&type=script&lang=ts"
import style0 from "./ImportBox.vue?vue&type=style&index=0&id=e18df318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18df318",
  null
  
)

export default component.exports